import { ArpMedia, PaginatedResponse } from '@arpeggi/shared'
import axios from '../../../__legacy__/lib/axios'
import { GetSongRemixesParams } from '../types/arpMedia'

export const getSongRemixes = async (arpMediaId: number, params: GetSongRemixesParams) => {
  const { data } = await axios.get<PaginatedResponse<ArpMedia>>(
    `/api/v2/songs/${arpMediaId}/remixes`,
    { params }
  )

  return data
}
